// import TokenDisplay from "@/components/TokenDisplay";
import ListModalAntd from "@/components/ListModalAntd";
import { Button, ConfigProvider, Form, Segmented, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import './index.less'
// import { getDexs } from "@/config/swap";
import { getDexs, getMemes, getStableCoins } from "@/config/dex";
import Loader from "@/components/Loader";
import { getChainsTokens } from "@/request/token";
import { useEffect, useMemo, useRef, useState } from "react";
import { getSymbol } from "@/config/symbol";
import { getNativeTokenInfo } from "@/request/native";
import { useNavigate } from "react-router-dom";
import { getChainsResource } from "@/utils/methods";
import { NET_ID } from "@/config";
import { cdnUrl } from '@/utils/cdn';

// const { stableCoins } = getDexs()
const stableCoins = getStableCoins();
const nativeCoin = getNativeTokenInfo();


export default function SwapTokenSetting({ form, onSwitch, isQueryLoading, queryRouter,
  tokenA,
  setTokenA,
  tokenB,
  setTokenB,
  isSelectOperate,
  setIsSelectOperate,
  isTokenANativeOrStable,
  isTokenBNativeOrStable,
  setTokenAInfo,
  setTokenBInfo,
}: any) {
  const firstRunRef = useRef(true);
  const navigate = useNavigate(); // 获取路由导航对象
  const nativeAndStableCoins = useMemo(() => ["0x2::sui::SUI", "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC", "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"], [])
  const { t, i18n } = useTranslation();
  const [tokens, setTokens] = useState<any>([]);
  const tokenARef = useRef<any>(null);
  const tokenBRef = useRef<any>(null);
  // console.log('tokens', tokens);
  // 用一个 ref 来记住上一次的 tokenA、tokenB
  const previousTokensRef = useRef<{ tokenA: string; tokenB: string } | null>(null);

  async function getTokens() {
    const { tokens: chainsTokens }: any = await getChainsTokens();
    nativeCoin.address = getSymbol();
    const tokens = [nativeCoin, ...stableCoins, ...chainsTokens]
    setTokens(tokens)
  }
  useEffect(() => {
    getTokens()
  }, [])

  console.log("tokenA", tokenA)
  console.log("tokenB", tokenB)
  useEffect(() => {
    if (tokenA && tokenB && isSelectOperate) {
      queryRouter();
    }

  }, [tokenA, tokenB]);

  console.log("isTokenBNativeOrStable", isTokenBNativeOrStable)
  console.log("isTokenANativeOrStable", isTokenANativeOrStable)
  return (
    <div className="form-section-lp">
      <h4>{t("batchSwap.swapTokenSettings")}</h4>
      <div>
        <div className="form-section-lp-row">
          <div className="title">
            From
          </div>
          <div className="form-el">
            <ListModalAntd
              ref={tokenARef}
              placeholder={t("tips.pleaseSelectToken")}
              searchPlaceholder={t("tips.pleaseInputSymbolOrAddress")}
              listType="all"
              value={tokenA}
              form={form}
              canClear={false}
              formKey="tokenA"
              // inputDisabled={isTokenANativeOrStable}
              filterAddrs={isTokenBNativeOrStable ? nativeAndStableCoins : []}
              getSelectedTokenInfo={(tokenInfo: any) => {
                console.log("tokenInfo", tokenInfo)
                if (tokenInfo && tokenInfo.coinType == tokenB) {
                  onSwitch();
                  return
                } else {
                  // setIsSelectOperate(true)
                }
                tokenInfo && setTokenA(tokenInfo?.coinType)
                setTokenAInfo({ ...tokenInfo })
              }}
            />
          </div>
        </div>
        <div className="switch-token" onClick={() => {
          // tokenARef.current?.onChangeToken(tokenB);
          // tokenBRef.current?.onChangeToken(tokenA);
          onSwitch()
        }} />
        <div className="form-section-lp-row">
          <div className="title">
            To
          </div>
          <div className="form-el">
            <ListModalAntd
              ref={tokenBRef}
              placeholder={t("tips.pleaseSelectToken")}
              searchPlaceholder={t("tips.pleaseInputSymbolOrAddress")}
              listType="all"
              value={tokenB}
              form={form}
              formKey="tokenB"
              canClear={false}
              filterAddrs={isTokenANativeOrStable ? nativeAndStableCoins : []}
              getSelectedTokenInfo={(tokenInfo: any) => {
                console.log("tokenBInfo", tokenInfo)
                if (tokenInfo && tokenInfo.coinType == tokenA) {
                  onSwitch();
                  return
                } else {
                  // setIsSelectOperate(true)
                }
                tokenInfo && setTokenB(tokenInfo?.coinType)
                setTokenBInfo({ ...tokenInfo })
              }}
            />
          </div>
        </div>
      </div>
      <div className="dex">
        <div>
          {
            <Button type="primary" className="query-btn" disabled={isQueryLoading === 1} onClick={queryRouter}>
              {
                isQueryLoading === 1
                &&
                <Loader>
                  <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
                </Loader>
              }
              {
                isQueryLoading === 2
                &&
                '✅ '
              }
              {t("batchSwap.queryPools")}
            </Button>
          }
        </div>

      </div>
    </div>
  )
}